import axios from "axios";

// In production, default to same-origin so frontend and API can be served from one AWS host.
// In development, use the local backend unless REACT_APP_API_BASE_URL is provided.
const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:8080" : "");

export const createConfessionRequest = (originatingEmail, message) => {
  return new Promise((resolve, reject) => {
    console.log("CREATING CONFESSION REQUEST")
    axios
      .post(apiBaseUrl + "/api/confessions", { originatingEmail, message })
      .then((response) => {
        resolve(response);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

export const viewPenanceRequest = (cnfs, password) => {
  return new Promise((resolve, reject) => {
    axios
      .post(apiBaseUrl + "/api/penances?cnfs=" + cnfs, { password })
      .then((response) => {
        console.log(response);
        resolve(response);
      })
      .catch((e) => {
        console.log("error " + e);
        reject(e);
      });
  });
};

export const deleteConfession = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(apiBaseUrl + "/api/confessions", { data: { id } })
      .then((response) => {
        console.log(response);
        resolve(response);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};

export const deleteConfessionViaPenance = (penanceUrl, password) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(apiBaseUrl + "/api/penances", { data: { penanceUrl, password } })
      .then((response) => {
        console.log(response);
        resolve(response);
      })
      .catch((e) => {
        console.log(e);
        reject(e);
      });
  });
};
